// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_extraLoadingStyle__xbbk0 div {
    width: 28px !important;
    height: 28px !important;
}

.styles_extraLoadingStyle__xbbk0 {
    height: 60px !important;
    width: 60px !important;
    align-items: center;
}

.styles_absoluteBg__ZU7T9 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.5;
}

.styles_serverError__EX6BA {
    position: absolute;
    bottom: 78px;
    padding: 0 20px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/OnlineChat/ChatPage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".extraLoadingStyle div {\n    width: 28px !important;\n    height: 28px !important;\n}\n\n.extraLoadingStyle {\n    height: 60px !important;\n    width: 60px !important;\n    align-items: center;\n}\n\n.absoluteBg {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0.5;\n}\n\n.serverError {\n    position: absolute;\n    bottom: 78px;\n    padding: 0 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extraLoadingStyle": `styles_extraLoadingStyle__xbbk0`,
	"absoluteBg": `styles_absoluteBg__ZU7T9`,
	"serverError": `styles_serverError__EX6BA`
};
export default ___CSS_LOADER_EXPORT___;
